import { LOCALES, DEFAULT_LANG, langPrefix } from "@/i18n/locales";
import { FEED_GEN } from "./feed_gen";

export function feedSlug(lang) {
  return (FEED_GEN[lang] || FEED_GEN[DEFAULT_LANG] || {}).slug;
}
export function feedData(lang) {
  return FEED_GEN[lang] || FEED_GEN[DEFAULT_LANG] || {};
}
export function feedPath(lang) {
  return `${langPrefix(lang)}/${feedSlug(lang)}`;
}
export function buildFeedAlternates(origin) {
  const o = (origin || (typeof window !== "undefined" ? window.location.origin : "")).replace(/\/$/, "");
  const alts = LOCALES.filter((l) => feedSlug(l.code)).map((l) => ({ hreflang: l.hreflang, href: `${o}${feedPath(l.code)}` }));
  if (feedSlug(DEFAULT_LANG)) alts.push({ hreflang: "x-default", href: `${o}${feedPath(DEFAULT_LANG)}` });
  return alts;
}
export const FEED_SLUGS = Object.fromEntries(LOCALES.map((l) => [l.code, feedSlug(l.code)]).filter(([, s]) => s));
